import { reactive } from 'vue';
import router from '@/router';
import partnerSwal from '../partnerSwal';

export const vehicleRequest = reactive({
  pickUpTimes(timeDetails) {
    let times = '';
    timeDetails.forEach((element, index) => {
      times += `${index ? ', ' : ''}${element.time}`;
    });
    return times;
  },
  decodeMapData(route_map) {
    if (route_map) {
      let mapData =
        typeof route_map !== 'object' ? JSON.parse(route_map) : route_map;
      mapData = mapData.mapJson ? mapData.mapJson : mapData;
      mapData = mapData.map_attributes ? mapData.map_attributes : mapData;

      if (
        typeof mapData === 'object' &&
        mapData.waypoints &&
        mapData.viaWaypoints &&
        mapData.pickData &&
        mapData.dropData
      ) {
        return mapData;
      } else {
        partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'Invalid Map Data!'
        });
        return null;
      }
    } else {
      return null;
    }
  },
  redirectToMap(requestRoute) {
    if (requestRoute?.route_map) {
      let mapData = this.decodeMapData(requestRoute.route_map);
      if (mapData) {
        localStorage.setItem('waypoints', JSON.stringify(mapData.waypoints));
        localStorage.setItem(
          'viaWaypoints',
          JSON.stringify(mapData.viaWaypoints)
        );
        localStorage.setItem('pickData', JSON.stringify(mapData.pickData));
        localStorage.setItem('dropData', JSON.stringify(mapData.dropData));

        router.push({ name: 'trip-map-show' });
      }
    } else {
      partnerSwal.warningToast.fire({
        title: 'Warning!',
        text: 'No Map Found!'
      });
    }
  },
  shuttleBonusObjFromBonusArray(bonusArray, bonusObj) {
    let shuttleBonusObj = {};
    if (bonusArray) {
      bonusArray.forEach((bonus) => {
        if (
          bonusObj[bonus.bonus_id] &&
          bonusObj[bonus.bonus_id].bonus_name === 'Shuttle Bonus'
        ) {
          shuttleBonusObj.type = bonus.type;
          shuttleBonusObj.base_bonus = bonus.base_bonus;
        }
      });
    }
    return shuttleBonusObj;
  },
  completionBonusFromBonusArray(bonusArray, bonusObj) {
    let completionBonus = 0;
    if (bonusArray) {
      bonusArray.forEach((bonus) => {
        if (
          bonusObj[bonus.bonus_id] &&
          bonusObj[bonus.bonus_id].bonus_name === 'Completion Bonus'
        ) {
          completionBonus = bonus.base_bonus;
        }
      });
    }
    return completionBonus;
  },
  dailyIncomeWithShuttleBonusWithoutTripTimes(
    farePerKm,
    distance,
    dutyDays,
    shuttleBonusType,
    shuttleBonus
  ) {
    let income = 0;

    if (farePerKm && distance) {
      income = farePerKm * distance;

      if (shuttleBonusType && shuttleBonus) {
        let bonusAmount = 0;
        if (
          shuttleBonusType === 'percentage' ||
          shuttleBonusType === 'PERCENTAGE'
        ) {
          bonusAmount = (income * shuttleBonus) / 100;
        } else if (
          (shuttleBonusType === 'flat' || shuttleBonusType === 'FLAT') &&
          dutyDays
        ) {
          bonusAmount = shuttleBonus / dutyDays;
        }
        income += bonusAmount;
      }
    }

    return parseFloat(parseFloat(income).toFixed(2));
  },
  dailyIncomeWithShuttleBonus(
    farePerKm,
    distance,
    dutyDays,
    tripTimes,
    shuttleBonusType,
    shuttleBonus
  ) {
    let income = 0;

    if (farePerKm && distance) {
      income = farePerKm * distance;
      if (tripTimes) {
        income *= tripTimes;
      }

      if (shuttleBonusType && shuttleBonus) {
        let bonusAmount = 0;
        if (
          shuttleBonusType === 'percentage' ||
          shuttleBonusType === 'PERCENTAGE'
        ) {
          bonusAmount = (income * shuttleBonus) / 100;
        } else if (
          (shuttleBonusType === 'flat' || shuttleBonusType === 'FLAT') &&
          dutyDays
        ) {
          bonusAmount = shuttleBonus / dutyDays;
        }
        income += bonusAmount;
      }
    }

    return parseFloat(parseFloat(income).toFixed(2));
  },
  weeklyIncomeWithShuttleBonus(
    farePerKm,
    distance,
    dutyDays,
    tripTimes,
    shuttleBonusType,
    shuttleBonus
  ) {
    let income = this.dailyIncomeWithShuttleBonus(
      farePerKm,
      distance,
      dutyDays,
      tripTimes,
      shuttleBonusType,
      shuttleBonus
    );

    if (income && dutyDays) {
      income *= dutyDays;
    }

    return parseFloat(parseFloat(income).toFixed(2));
  },
  weeklyIncomeWithShuttleAndCompletionBonus(
    farePerKm,
    distance,
    dutyDays,
    tripTimes,
    shuttleBonusType,
    shuttleBonus,
    completionBonus
  ) {
    let income = this.weeklyIncomeWithShuttleBonus(
      farePerKm,
      distance,
      dutyDays,
      tripTimes,
      shuttleBonusType,
      shuttleBonus
    );

    if (income && completionBonus) {
      income += completionBonus;
    }

    return parseFloat(parseFloat(income).toFixed(2));
  },
  returnRoute(requestRoutes, selectedRouteId) {
    let returnRoute = null;
    requestRoutes.forEach((requestRoute) => {
      if (
        requestRoute.id !== selectedRouteId &&
        requestRoute.status === 'Accepted'
      ) {
        returnRoute = requestRoute;
      }
    });
    return returnRoute;
  }
});
